var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#52bd00",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.947 511.947",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M508.827,115.067L434.16,40.4c-4.16-4.16-10.88-4.16-15.04,0l-259.2,259.2l-67.093-67.093c-4.16-4.16-10.88-4.16-15.04,0 L3.12,307.173c-4.16,4.16-4.16,10.88,0,15.04l149.333,149.333c4.16,4.16,10.88,4.16,15.04,0l341.333-341.333 C512.987,126.053,512.987,119.227,508.827,115.067z M159.92,448.933L25.627,314.64l59.627-59.627l67.093,67.093 c4.16,4.16,10.88,4.16,15.04,0l259.2-259.093l59.627,59.627L159.92,448.933z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.a1c359462d370dd2e5e144dd8dc7cb00.svg";
export { ForwardRef as ReactComponent };